import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '_services/Redux/store';
import { Toaster } from '@consolidocs-ui/components';
import { useToast, ToastItem } from '@consolidocs-ui/utils';

export const ToasterWrapper: React.FC = () => {
  const toasts = useSelector((state: RootState) => state.toast.toasts);
  const [, closeToast] = useToast();

  return (
    <Toaster
      toasts={toasts.map((toast: ToastItem) => ({
        id: toast.id,
        message: toast.message,
        color: toast.type,
        variant: toast.variant,
        direction: toast.direction,
        size: toast.size,
      }))}
      onClose={closeToast}
    />
  );
};
